import { ar } from "./translations/ar";
import { bn } from "./translations/bn";
import { en, type TranslationDict } from "./translations/en";

// Per-locale dictionaries live in ./translations/<locale>.ts (400-line cap).
// This module stays the stable import path for all consumers.
export const TRANSLATIONS = { en, bn, ar };

export type TranslationLanguage = keyof typeof TRANSLATIONS;
export type TranslationCategory = keyof typeof TRANSLATIONS.en;

/** A language's dictionary, for server code; English for a language without one. */
export function translationsFor(lang: string): TranslationDict {
  return Object.hasOwn(TRANSLATIONS, lang) ? TRANSLATIONS[lang as TranslationLanguage] : TRANSLATIONS.en;
}
